// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8dcb7256","453":"2600895f","455":"94416a8b","977":"985faabd"}[chunkId] + ".chunk.js";
};